import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import VytalPartners from "./components/VytalPartners";
import { AppContainer, LoadingContainer } from "./AppContainer";
import { getCustomPinColorStyles } from "./utils/customColors";

const LAT = parseFloat(document.querySelector('meta[name="lat"]').content);
const LNG = parseFloat(document.querySelector('meta[name="lng"]').content);
const ZOOM = parseFloat(document.querySelector('meta[name="zoom"]').content);
const SHOWSEARCH = document.querySelector('meta[name="showSearch"]').content;
const WOLT = document.querySelector('meta[name="wolt"]').content;


const App = () => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const [zoom, setZoom] = useState(ZOOM);
  const [bounds, setBounds] = useState(null);
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    fetch('https://vytal-website.s3.eu-central-1.amazonaws.com/store-map-export/stores.json')
      .then(response => response.json())
      .then(stores => {
        setStores(stores)
        setLoading(false)
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      })
  }, [])

  const onBoundsChanged = (e) => {
    setBounds(e.bounds)
    setZoom(e.zoom)
  }

  const customPinColorStyles = getCustomPinColorStyles();

  return (
    <AppContainer style={customPinColorStyles}>
      {error && <LoadingContainer>Error! ${error.message}</LoadingContainer>}
      <VytalPartners
        language={language}
        defaultCenter={{ lat: LAT, lng: LNG }}
        defaultZoom={ZOOM}
        showSearch={false /* disabled for now, until we use a google places api alternative (here api) // SHOWSEARCH === "yes" */}
        stores={stores}
        currentZoom={zoom}
        currentBounds={bounds}
        onBoundsChanged={onBoundsChanged}
        loading={loading}
      />
    </AppContainer>
  );
};

export default App;

/*
      <SubContainer>
        {/* Here you can put whatever you want in the new container }
        </SubContainer>

                <ProductContainer></ProductContainer>


                          storeName={storeData.store}
          storeImg={storeData.store.image_urls[0]}
          storeBrandName={storeData.store.brand.name}

          storeName={storeData.store}
          storeImg={storeData.store.image_urls[0]}
          storeBrandName={storeData.store.brand.name}
*/
